import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchBrandApiClient extends AdvancedApiClient {

    static entityType = "FarfetchBrand"

    constructor(token, channelId) {
        super();

        this.setEntityType(FarfetchBrandApiClient.entityType)
            .setRoute("/api/v1/channel/{id}/farfetch/brand")
            .setRouteParam("id", channelId);
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}